export const getDefaultFilters = (query = '') => ({
  query,
});

export const COMPANY_TYPES_MAP = {
  buyer: 'Buyer',
  lender: 'Lender',
  builder: 'Builder',
  bank: 'Bank',
  title_company: 'Title company',
  blacklisted: 'Blacklisted',
  government_entity: 'Government entity',
};

export const COMPANY_TYPES_COLORS = {
  buyer: 'geekblue',
  lender: 'gold',
  builder: 'volcano',
  bank: 'green',
  title_company: 'purple',
  government_entity: 'cyan',
};
